'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AllowedCustomOpts = {
  MEETING_SIDEBAR: 'MEETING_SIDEBAR',
  SALES_EXTENSION_SIDEBAR: 'SALES_EXTENSION_SIDEBAR'
};

exports.default = AllowedCustomOpts;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/signup-ui-core/static-1.15/js/constants/AllowedCustomOpts.js
// module id = 142
// module chunks = 0